import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from '../utils/functions';

const $employeeListEl = $('.employee-list');

$(function () {
    if ($employeeListEl.length > 0) {
        $employeeListEl.each(function () {
            employeeList($(this));
        });
    }
});

const employeeList = (listEl) => {
    const filter = {
        page: 1,
        limit: listEl.data('limit'),
        categories: listEl.data('categories'),
        search: '',
        lang: listEl.data('lang'),
    };

    bindPagination(listEl, filter);
    bindEmployeeFilter(listEl, filter);
};

const reRenderList = async (element, filter, scrollTop = false) => {
    const data = await getEmployees(filter);
    element.find('.employee-list__content').html(data.html);

    if (scrollTop === true) {
        smoothscroll(element, 'header');
    }
};

const bindPagination = (element, filter) => {
    element.on('click', '.pagination__item', function () {
        filter.page = $(this).data('page');
        reRenderList(element, filter, true);
    });
};

const bindEmployeeFilter = (element, filter) => {

    element.on(
        'input',
        "input[name='employee-filter-input-search']",
        debounce(function () {
            const $input = $(this);
            filter.page = 1;
            filter.search = $input.val();

            if (filter.search) {
                $input.parent().addClass('has-value');
            } else {
                $input.parent().removeClass('has-value');
            }
            reRenderList(element, filter);
        })
    );

    element.on('change', "select[name='employee-filter-select-category']", function () {
        filter.page = 1;
        filter.employeeCategory = $(this).val();
        reRenderList(element, filter);
    });

    element.on('click', "button[name='employee-filter-input-reset']", function () {
        element.find("input[name='employee-filter-input-search']").val('').trigger('input');
    });

};

const getEmployees = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/nitra/v1/employee/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
